import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Button from "../../components/Common/Button";
import ConditionalRender from "../../components/Common/ConditionalRender";
import { useHandleClickLoading } from "../../components/Common/utils";

const PopularnCategoryItems = ({ productData, productLoading, listProduct, tabcategroy, setTabCategory }) => {
    const isWebSetting = localStorage.getItem('isWebSetting');
    const parseWebSetting = JSON.parse(isWebSetting);

    const [screenSize, setScreenSize] = useState(window.innerWidth);
    const sliceSize = getSliceSize(screenSize);

    useEffect(() => {
        const handleResize = () => setScreenSize(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function getSliceSize(size) {
        if (size < 640) return 9; // sm
        if (size < 768) return 8; // md
        if (size < 1024) return 10; // lg
        if (size < 1280) return 12; // xl
        return 14; // xxl
    }

    const handleClickLoading = useHandleClickLoading();
    return (
        <div className="flex flex-col gap-3">
            <div className="flex relative overflow-x-scroll no-scrollbar h-9">
                <div className="flex flex-row absolute top-0 left-3 right-3 bottom-0">
                    {productData.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`flex  group bg-gradient-to-r  ${tabcategroy === item.jenis ? "from-[#22BDE2] to-[#FC00FF] " : "bg-[#D8E7FF] dark:bg-[#D8E7FF]"} px-4 p-2 items-center justify-center rounded-full mx-1`}
                            >
                                <button
                                    onClick={() => {
                                        if (item.jenis === tabcategroy) {
                                            setTabCategory(item.jenis);

                                        } else {
                                            setTabCategory(item.jenis);
                                        }
                                    }}
                                    className="flex flex-row items-center justify-center  h-full ">
                                    <span className={`text-xs text-center whitespace-nowrap ${tabcategroy === item.jenis ? "text-darkColor " : ""} line-clamp- `}>
                                        {item.jenis}
                                    </span>
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
            {tabcategroy === '' ? null :
                <div className="flex flex-col gap-3">
                    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7  gap-2 px-3 mt-2  pt-2 ">
                        <ConditionalRender
                            productsData={listProduct}
                            isLoading={productLoading}
                            model={"emptyData"}
                        >
                            {listProduct.map((item, index) => {
                                return (
                                    tabcategroy === item.jenis &&
                                    <div
                                        key={index} className="flex flex-col overflow-hidden rounded-lg aspect-[1/1.3] ">
                                        <div
                                            className="flex flex-col flex-1 h-full gap-1 group cursor-pointer"
                                            onClick={() => {
                                                handleClickLoading('/beli/' + item.slug)
                                            }}>
                                            <div className="relative flex flex-col bg-[#2121210f] dark:bg-[#f3f3f30f] flex-1 h-full overflow-hidden ">
                                                <LazyLoadImage
                                                    src={item.gambar}
                                                    alt={item.nama}
                                                    height={"100%"}
                                                    className=" w-full h-full object-cover group-hover:blur-xl"
                                                    effect="blur"
                                                />
                                                <div className="absolute w-full h-full hidden items-center justify-center group-hover:flex">
                                                    <img
                                                        src={parseWebSetting?.favicon}
                                                        alt="Logo"
                                                        width={'50%'}
                                                        height={'50%'}
                                                        className="white-filter"
                                                    />
                                                </div>
                                                <div className="absolute bottom-0 w-full bg-[#22BDE2df] flex flex-col text-darkColor justify-center sm:h-11 h-9 ">
                                                            <span className=" sm:text-sm text-xs text-center line-clamp-2">
                                                                {item.nama}
                                                            </span>
                                                        </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </ConditionalRender>
                    </div>
                    <div className="flex flex-row justify-center">
                        <div>
                            <Button
                                initialValue="Tampilkan Semua"
                                type="fill"
                                className="border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor inline-flex rounded-md"
                                onClick={() => { handleClickLoading('/allgames') }}
                            />
                        </div>
                    </div>
                </div>}
        </div>
    );
}

export default PopularnCategoryItems;